<template>
  <div>
    <div class="wrapper wrapper-full-page auth-container" >
      <nav class="navbar navbar-expand-lg navbar-transparent navbar-absolute">
        <div class="container">
          <div class="navbar-wrapper">
            <a class="navbar-brand" href="https://everinvestor.com.br">
              <img
                width="120"
                src="static/img/everinvestor/logo-w.png"
              >
            </a>
          </div>
        </div>
      </nav>
      <div :data-color="backgroundColor" :class="pageClass">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple | black" -->
        <div class="content">
          <div class="container">
            <slot></slot>
          </div>
        </div>
        <footer class="footer footer-transparent auth-footer">
          <div
            class="container d-flex flex-lg-row flex-column justify-content-lg-between justify-content-center align-items-center"
          >
            <div class="copyright">
              &copy;
              <a  href="https://everinvestor.com.br" target="_blank">Ever Investor</a> 2021. Feito com
              <i class="fa fa-heart heart"></i> pela equipe
              <a  href="https://everinvestor.com.br" target="_blank">dEvI</a>.
            </div>
          </div>
        </footer>

      </div>
    </div>
    <div class="collapse navbar-collapse off-canvas-sidebar">
      <ul class="nav nav-mobile-menu">
        <router-link to="/register" tag="li">
          <a>Register</a>
        </router-link>
        <router-link to="/admin/overview" tag="li">
          <a>Dashboard</a>
        </router-link>
      </ul>
    </div>
  </div>
</template>
<script>
import CollapseTransition from "element-ui/lib/transitions/collapse-transition";

export default {
  components: {
    [CollapseTransition.name]: CollapseTransition
  },
  props: {
    pageClass: {
      type: String,
      default: "login-page"
    },
    backgroundColor: {
      type: String,
      default: "toptrader"
    }
  },
  data() {
    return {
      showMenu: false
    };
  },
  methods: {
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      document.body.classList.remove("off-canvas-sidebar");
    }
  },
  beforeDestroy() {
    this.closeMenu();
  }
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
.navbar-wrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
}
.wrapper-full-page .navbar-toggler,
.wrapper-full-page .navbar-collapse .navbar-nav {
  margin-right: 30px;
}
.navbar-collapse .navbar-nav .nav-link {
  width: 100%;
  display: flex;
  justify-content: center;
}

.auth-container{
  background-image: url(/static/img/candles.jpg);
  background-size: cover;
}

.auth-footer{
  position: absolute !important;
  margin-top: 20px;
  bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/AuthLayout.vue